// Certificate.jsx
import React, { useState, useContext, useEffect } from "react";
import "./Certificate.scss";
import MyContext from "../Context/MyContext";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CertificateImage from "../../assets/certi-placeholder.png";
import { requestFormReset } from "react-dom";

const Certificate = () => {
  const [screenshot, setScreenshot] = useState(null);
  const [isApproved, setIsApproved] = useState(false);

  const { usertoken, url, setLoader, setMessage, setOpen } =
    useContext(MyContext);

  // Check approval status
  useEffect(() => {
    const checkStatus = async () => {
      if (!usertoken?.email) return;

      try {
        const res = await fetch(
          `${url}/api/check-certificate-status/${usertoken.email}`
        );
        const data = await res.json();
        setIsApproved(data.approved);
      } catch (err) {
        console.error("Status check error", err);
      }
    };

    checkStatus();
  }, [usertoken?.email]);

  //  Download certificate
  const generateCertificate = async () => {
    if (!isApproved) return;

    setLoader(true);
    try {
      const res = await fetch(
        `${url}/api/generate-certificate/${usertoken.email}`
      );
      const blob = await res.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "certificate.pdf";
      a.click();
    } catch (err) {
      setMessage(" Failed to download certificate.");
      setOpen(true);
    } finally {
      setLoader(false);
    }
  };

  // Handle file
  const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]);
  };

  //  Upload screenshot
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!screenshot || !usertoken?.email) {
      alert("Missing screenshot or user data.");
      return;
    }

  setOpen(true)
setMessage('Thanks screenshot uploaded successfully. Under review (24–48 hrs)')   
setScreenshot(null)
  };

  return (
    <div className="certificate-page">
      {/* HEADER */}
      <h2> Internship Certificate & Completion Letter</h2>
      <p>
        Complete the final step to receive your <strong>Certificate</strong> and{" "}
        <strong>Completion Letter</strong> directly on your registered email.
      </p>

      {/* STEPS */}
      <div className="requirements-section">
        <h3>Follow these steps to unlock your certificate:</h3>
        <ol className="steps-list">
          <li> Submit your honest review on our Google page</li>
          <li> Take a clear screenshot of your posted review</li>
          <li> Upload the screenshot below</li>
          <li> Our team will verify your review, attendance & project</li>
          <li> Certificate & Letter will be sent to your email</li>
        </ol>
      </div>

      {/* REVIEW SECTION */}
      <div className="review-section">
        <a
          href="https://g.page/r/CdSs-ZKlwiUMEAI/review"
          target="_blank"
          rel="noopener noreferrer"
          className="google-review-link"
        >
           Leave a Google Review
        </a>

        <form onSubmit={handleSubmit} className="screenshot-upload-form">
          <div className="upload-instructions">
            <p>
              <strong>Step 2:</strong> Upload your review screenshot
            </p>
            <p className="note">
              Make sure your name & review are clearly visible.
            </p>
          </div>

          <input type="file" accept="image/*" onChange={handleFileChange} required />

          <button type="submit">Submit Screenshot</button>
        </form>
      </div>

      {/* CERTIFICATE PREVIEW */}
      <div
        className={`certificate-container ${
          isApproved ? "unlocked" : "locked"
        }`}
      >
        <img
          src={CertificateImage}
          alt="Certificate Preview"
          className="certificate-preview"
        />

        <div className="certificate-overlay">
          {isApproved ? (
            <>
              <LockOpenIcon className="unlock-icon" />
              <p>Your certificate is ready! 🎉</p>
              <p className="verification-note">
                📩 Certificate & Completion Letter sent to your email
              </p>
              <button onClick={generateCertificate} className="download-btn">
                Download Certificate
              </button>
            </>
          ) : (
            <>
              <LockIcon className="lock-icon" />
              <p>🔒 Complete the steps to unlock your certificate</p>

              <p className="verification-note">
                {screenshot
                  ? "⏳ Under review (24–48 hrs)"
                  : "Upload screenshot to proceed"}
              </p>

              <button className="disabled-btn" disabled>
                {screenshot ? "Pending Verification" : "Upload Screenshot First"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Certificate;